@for (field of fields; track field) {
	<div class="form-group">
		<label>{{ field | langVal }}</label>
		<app-gen-input
			[tabindex]="`${$index + 1}`"
			[actualObj]="sendObj"
			[fieldName]="field"
		></app-gen-input>
	</div>
}

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<button
		tabindex="11"
		class="btn btn-primary"
		(click)="returnText()"
	>
		{{ "insert_text" | langVal }}
	</button>
</div>
